import { all, takeEvery, put, call } from "redux-saga/effects";
import actions from "./actions";
import { getList, addData } from "../../helpers/fackBackend_Helper";


function* getPlanPriceConfigListResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/PriceConfigure/PriceFetchDeatils", data);
        if (response?.statusCode === 1200) {
            yield put(actions.getPlanPriceConfigListSuccess(response?.data));
        } else {
            yield put(actions.getPlanPriceConfigListError(response?.message));
        }
    } catch (error) {
        yield put(actions.getPlanPriceConfigListError(error?.message || error)
        );
    }
}


function* updatePlanPriceConfigResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/PriceConfigure/PriceUpdate", data);
        if (response?.statusCode === 1200) {
            yield put(actions.updatePlanPriceConfigSuccess(response?.message));
        } else {
            yield put(actions.updatePlanPriceConfigError(response?.message));
        }
    } catch (error) {
        yield put(actions.updatePlanPriceConfigError(error?.message || error)
        );
    }
}

function* updateSIMSwapPriceConfigResponse({ payload: { data } }) {
    try {
        const response = yield call(addData, "/API/V1/PriceConfigure/PriceSwapUpdate", data);
        if (response?.statusCode === 1200) {
            yield put(actions.updatePlanPriceConfigSuccess(response?.message));
        } else {
            yield put(actions.updatePlanPriceConfigError(response?.message));
        }
    } catch (error) {
        yield put(actions.updatePlanPriceConfigError(error?.message || error)
        );
    }
}

// ROOT SAGA
export default function* rootSaga() {
    yield all([
        takeEvery(actions.GET_PLAN_PRICE_CONFIG_LIST, getPlanPriceConfigListResponse),
        takeEvery(actions.UPDATE_PLAN_PRICE_CONFIG, updatePlanPriceConfigResponse),
         takeEvery(actions.UPDATE_SIMSwap_PRICE_CONFIG, updateSIMSwapPriceConfigResponse),
    ]);
}